import { TileMenuItem } from "@/api/dtos";
import { Divider } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { StyledList } from "..";
import ExpandableMenuItem from "./ExpandableMenuItem";
import MenuItemContents from "./MenuItemContents";
import { ITrial } from "@/components/TrialsArea";

interface IRecursiveMenuItem {
    menuItem: TileMenuItem;
    finalInList: boolean;
    finalComponent: boolean;
    trial: ITrial;
    tileData?: Record<string, string>;
    expandedMenuItemsNonFav?: Record<number, boolean> | undefined;
    toggleExpandedMenuItem?: (trialId: number, expandMenuItemId: number) => void | undefined;
    toggleExpandedMenuItemNonfav?: (expandMenuItemId: number) => void | undefined;
}

const RecursiveMenuItem: React.FunctionComponent<IRecursiveMenuItem> = ({
    menuItem,
    finalInList,
    finalComponent,
    trial,
    tileData,
    expandedMenuItemsNonFav,
    toggleExpandedMenuItem,
    toggleExpandedMenuItemNonfav
}) => { 

    return (
        <>
            {
                !!menuItem.expandable ?
                    <Fragment key={menuItem.name}>
                        <ExpandableMenuItem
                            tileMenuItem={menuItem}
                            tileData={tileData}
                            trial={trial}
                            toggleExpandedMenuItem={toggleExpandedMenuItem}
                            toggleExpandedMenuItemNonfav={toggleExpandedMenuItemNonfav}
                            expandedMenuItemsNonFav={expandedMenuItemsNonFav}
                        />
                    </Fragment>
                :
                    <Fragment key={menuItem.name}>

                        <MenuItemContents 
                            menuItem={menuItem}
                            tileData={tileData}
                        />

                        {
                            menuItem.subTileMenuItems !== null && menuItem.subTileMenuItems !== undefined &&
                            <StyledList
                                disablePadding
                            >
                            {
                                menuItem.subTileMenuItems.map((menuItem, i, entireList ) => (
                                        <RecursiveMenuItem 
                                            menuItem={menuItem} 
                                            finalInList={(i === entireList.length-1)} 
                                            finalComponent={(i === entireList.length-1) && finalComponent} 
                                            trial={trial}
                                            toggleExpandedMenuItem={toggleExpandedMenuItem}
                                            toggleExpandedMenuItemNonfav={toggleExpandedMenuItemNonfav}
                                            expandedMenuItemsNonFav={expandedMenuItemsNonFav}
                                            tileData={tileData}
                                        />

                                ))
                            }
                            </StyledList>
                        }
                    </Fragment>
            }
            {
                (!finalInList || (!!finalComponent && !!finalInList)) && (
                    <Divider />
                )
            }
        </>
    );
}

export default RecursiveMenuItem;